import React from 'react';
import './App.css';

import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import Engine from '../src/components/pages/engine';
import Login from './components/pages/login';
import Painel from'./components/pages/painel';
import Calendario from './components/pages/calendario';
import Tokens from './components/pages/tokens';
import Perfil from './components/pages/Perfil';
import Projeto from './components/pages/projeto';
import Pagemobilemenu from './components/pages/pagemobilemenu';
import PageTeste from'./components/pages/teste'

function App() {
  return (
  <BrowserRouter>

    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/painel" element={<Painel />} />
      <Route path="/calendario" element={<Calendario />} />
      <Route path="/engine" element={<Engine />} />
      <Route path="/tokens" element={<Tokens />} />
      <Route path="/perfil" element={<Perfil />} />
      <Route path="/projeto" element={<Projeto />} />
      <Route path="/pagemobilemenu" element={<Pagemobilemenu />} />
      <Route path="/teste" element={<PageTeste />} />
    </Routes>
  </BrowserRouter>
  )
}

export default App;
